export default {
  'address-form:first-name-label': 'First name',
  'address-form:last-name-label': 'Last name',
  'address-form:street-label': 'Street + No.',
  'address-form:additional-details-label': 'Address suffix / Company / C/O / Post number',
  'address-form:zip-label': 'ZIP code',
  'address-form:town-label': 'City',
  'address-form:country-label': 'Country',
  'address-form:phone-label': 'Phone number',
};
